import { createContext, useContext, useState, ReactNode, useMemo } from "react"

interface MapMenuContextType {
  height: number
  setHeight: (height: number) => void
  headerHeight: number
  setHeaderHeight: (height: number) => void
}

const MapMenuContext = createContext<MapMenuContextType | undefined>(undefined)

export function MapMenuProvider({ children }: { children: ReactNode }) {
  const [height, setHeight] = useState(0)
  const [headerHeight, setHeaderHeight] = useState(0)

  // Temporary
  const formattedHeight = useMemo(() => {
    return height + headerHeight
  }, [height, headerHeight])

  return (
    <MapMenuContext.Provider
      value={{
        height: formattedHeight,
        setHeight,
        headerHeight,
        setHeaderHeight,
      }}
    >
      {children}
    </MapMenuContext.Provider>
  )
}

export function useMapMenu() {
  const context = useContext(MapMenuContext)
  if (!context) {
    throw new Error("useMapMenu must be used within a MapMenuProvider")
  }
  return context
}
